import { withFormik } from "formik";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import Dropzone from "react-dropzone";
import { Trans } from "react-i18next";
import { baseValue, downloadFile } from "../../libs/utils";
import {
  addFileToCrewMember,
  removeFileFromCrewMember
} from "../../services/api/crewMembers";
import { getUsersForCurrentUser } from "../../services/api/users";
import "../../styles/vendor/react-checkbox-tree.css";
import BasicCheckbox from "./fields/BasicCheckbox";
import BasicInput from "./fields/BasicInput";
import BasicSelect from "./fields/BasicSelect";
import FullCalendar from "./fields/FullCalendar";

class InnerForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            days: [],
            occupations: [],
            newFiles: [],
            deletedDocs: []
        };

        this._handleDateSelection = this._handleDateSelection.bind(this);
        this._dayRender = this._dayRender.bind(this);
        this._handleProfileChange = this._handleProfileChange.bind(this);
        this._handleSearchUser = this._handleSearchUser.bind(this);
        this._handleChangeUser = this._handleChangeUser.bind(this);
        this._onDrop = this._onDrop.bind(this);
        this._deleteFile = this._deleteFile.bind(this);
    }

    static propTypes = {
        handleSubmit: PropTypes.func,
        isSubmitting: PropTypes.bool,
        parking: PropTypes.object,
        setValues: PropTypes.func,
        isCreating: PropTypes.bool,
        setFieldValue: PropTypes.func,
        registration: PropTypes.object,
        user: PropTypes.object,
        close: PropTypes.func,
        visible: PropTypes.bool,
        crewMember: PropTypes.object,
        crewMemberId: PropTypes.any
    };

    UNSAFE_componentWillMount() {
        const {crewMember} = this.props;

        if (crewMember && crewMember.id) {
            this._setUpCrewMember(crewMember);
        }
    }

    _setUpCrewMember(crewMember) {
        this.setState({
            days: crewMember.days
        });

        // getOccupations({
        //   'filter[profile_id]': crewMember.profileId,
        //   'page[size]': 50
        // }).then(occupations => {
        //   this.setState({occupations: occupations.data});
        // });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let {crewMember} = nextProps;
        const currentProps = this.props;

        if (currentProps.crewMember !== crewMember) {
            const cm = baseValue(crewMember, {});

            currentProps.setValues({
                crewMemberId: baseValue(this.props.crewMemberId),
                id: baseValue(cm.id),
                userId: baseValue(cm.userId),
                profileId: baseValue(cm.profileId),
                //occupationId: baseValue(cm.occupationId),
                occupation: baseValue(cm.occupation),
                camping: cm.camping ?? false,
                allowCombiVouchers: cm.allowCombiVouchers ?? false,
                days: baseValue(cm.days, []),
                vegetarian: cm.dietaryPreferences.includes('vegetarian')
            });

            if (crewMember && crewMember.id) {
                this._setUpCrewMember(crewMember);
            }
        }

        if (currentProps.visible && !nextProps.visible) {
            currentProps.resetForm();
            this.setState({
                days: [],
                users: []
            });
        }
    }

    _handleDateSelection(startObj, endObj) {
        const days = [].concat(this.state.days);
        const diff = endObj.diff(startObj, "days");

        for (let i = 0; i < diff; i++) {
            let start = moment(startObj);
            const datestring = start.add(i, "days").format("YYYY-MM-DD");
            const index = days.indexOf(datestring);
            if (index === -1) {
                days.push(datestring);
            } else {
                days.splice(index, 1);
            }
        }

        this.setState({days});
        this.props.setFieldValue("days", days);
    }

    _dayRender(date, cell) {
        if (this.state.days.indexOf(date.format("YYYY-MM-DD")) > -1) {
            cell.css("background-color", "#34bfa3");
            cell.css("textColor", "#ffffff");
        }
    }

    _handleProfileChange(e) {
        // getOccupations({
        //   'filter[profile_id]': e.target.value,
        //   'page[size]': 50
        // }).then(occupations => {
        //   this.setState({occupations: occupations.data});
        // });
    }

    _handleSearchUser(value) {
        getUsersForCurrentUser(this.props.registration.company.id, {
            "filter[full_name]": value,
            "filter[exclude_crew_members_for_registration]": this.props.registration
                .id,
            include: "user"
        }).then(response => {
            this.setState({
                users: response.data
            });
        });
    }

    _handleChangeUser(values) {
        if (values.length > 0) {
            this.props.setFieldValue("userId", values[0].userId);
        } else {
            this.props.setFieldValue("userId", "");
        }
    }

    _onDrop(acceptedFiles, rejectedFiles) {
        acceptedFiles.forEach(file => {
            let data = new FormData();
            data.append("file", file);
            addFileToCrewMember(this.props.crewMember.id, data).then(response => {
                this.setState({
                    newFiles: [response].concat(this.state.newFiles)
                });
            });
        });
    }

    _deleteFile(doc) {
        removeFileFromCrewMember(this.props.crewMember.id, doc.id).then(data => {
            this.setState({
                deletedDocs: [doc.id].concat(this.state.deletedDocs)
            });
        });
    }

    render() {
        const props = this.props;
        const {
            handleSubmit,
            event,
            registration,
            close,
            crewMember,
            admin
        } = props;
        const {users, newFiles, deletedDocs} = this.state;

        let validRange = undefined;
        if (event.startsAt) {
            validRange = {
                start: event.startsAt.split(" ")[0],
                end: event.endsAt.split(" ")[0]
            };
        }

        const isCurrentDateInRange = validRange
            ? moment().isBetween(moment(validRange.start), moment(validRange.end))
            : false;

        const middle = moment(validRange.start).add(
            moment(validRange.end).diff(moment(validRange.start), "days") / 2,
            "days"
        );

        const focusedCalendarDate = isCurrentDateInRange ? moment() : middle;

        console.log('props', props)
        return (
            <form className="m-login__form m-form" onSubmit={handleSubmit}>
                <input type="hidden" name="id"/>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="form-group m-form__group">
                                <label>Name</label>
                                {crewMember && crewMember.user ? (
                                    <input
                                        className="form-control m-input"
                                        disabled
                                        type="text"
                                        name="name"
                                        id=""
                                        value={`${crewMember.user.firstName} ${crewMember.user.lastName}`}
                                    />
                                ) : (
                                    <div>
                                        <AsyncTypeahead
                                            multiple={false}
                                            options={users}
                                            isLoading={false}
                                            placeholder={"Search ..."}
                                            minLength={2}
                                            labelKey={item =>
                                                item.user.firstName + " " + item.user.lastName
                                            }
                                            ref={this.destinationUserIdsTA}
                                            onSearch={this._handleSearchUser}
                                            onChange={this._handleChangeUser}
                                        />

                                        {admin && (
                                            <div>
                                                <div className="text-center m--margin-top-10">
                                                    - OR -
                                                </div>
                                                <BasicInput
                                                    {...props}
                                                    name="firstName"
                                                    type="text"
                                                    label="First Name"
                                                />
                                                <BasicInput
                                                    {...props}
                                                    name="lastName"
                                                    type="text"
                                                    label="Last Name"
                                                />
                                                <div className="m-form__seperator m-form__seperator--dashed"/>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>

                            <BasicSelect
                                {...props}
                                name="profileId"
                                label="Profile"
                                placeholder="Select Profile"
                                onChange={this._handleProfileChange}
                                options={registration.registrationProfiles.map(profile => {
                                    return {
                                        title: profile.profile.name,
                                        value: profile.profile.id
                                    };
                                })}
                            />

                            {/*<BasicSelect*/}
                            {/*{...props}*/}
                            {/*name="occupationId"*/}
                            {/*label="Function"*/}
                            {/*placeholder={occupations.length > 0 ? 'Choose Function' : 'Select Profile First'}*/}
                            {/*onChange={this._handleOccupationsChange}*/}
                            {/*options={occupations.map(occupation => {*/}
                            {/*return {*/}
                            {/*title: occupation.name,*/}
                            {/*value: occupation.id*/}
                            {/*};*/}
                            {/*})}*/}
                            {/*/>*/}

                            <BasicInput
                                {...props}
                                name="occupation"
                                type="text"
                                label="Function Description"
                            />
                            <BasicCheckbox {...props} name="camping" label="Crew Camping"/>
                            {admin && (
                                <BasicCheckbox {...props} name="allowCombiVouchers" label="Allow Combi Vouchers"/>)}

                            {admin && (
                                <BasicCheckbox
                                    {...props}
                                    name="vouchers"
                                    label="Generate Vouchers"
                                />
                            )}
                            <BasicCheckbox {...props} name="vegetarian" label="Vegetarian"/>
                            {crewMember && (
                                <div>
                                    {(crewMember.documents.length > 0 || newFiles.length > 0) && (
                                        <div className="m-list-search">
                                            <div className="m-list-search__results">
                                                {crewMember.documents.map(doc =>
                                                    deletedDocs.indexOf(doc.id) === -1 ? (
                                                        <div key={doc.id} className="row">
                                                            <div className="col-sm-10">
                                                                <a
                                                                    className="m-list-search__result-item"
                                                                    onClick={() =>
                                                                        downloadFile(
                                                                            `crew-members/${crewMember.id}/documents/${doc.id}`,
                                                                            doc.fileName
                                                                        )
                                                                    }
                                                                >
                                                                    <span className="m-list-search__result-item-icon">
                                                                        <i className="flaticon-file m--font-warning"/>
                                                                    </span>
                                                                    <span className="m-list-search__result-item-text">
                                                                        {doc.fileName}
                                                                    </span>
                                                                </a>
                                                            </div>
                                                            <div className="col-sm-2">
                                                                <i
                                                                    className="flaticon-cancel  m--font-danger"
                                                                    onClick={() => this._deleteFile(doc)}
                                                                />
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        ""
                                                    )
                                                )}
                                                {newFiles.map(doc =>
                                                    deletedDocs.indexOf(doc.id) === -1 ? (
                                                        <div key={doc.id} className="row">
                                                            <div className="col-sm-10">
                                                                <a
                                                                    className="m-list-search__result-item"
                                                                    onClick={() =>
                                                                        downloadFile(
                                                                            `crew-members/${crewMember.id}/documents/${doc.id}`,
                                                                            doc.fileName
                                                                        )
                                                                    }
                                                                >
                                                                    <span className="m-list-search__result-item-icon">
                                                                        <i className="flaticon-file m--font-warning"/>
                                                                    </span>
                                                                    <span className="m-list-search__result-item-text">
                                                                        {doc.fileName}
                                                                    </span>
                                                                </a>
                                                            </div>
                                                            <div className="col-sm-2">
                                                                <i
                                                                    className="flaticon-cancel  m--font-danger"
                                                                    onClick={() => this._deleteFile(doc)}
                                                                />
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        ""
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    <Dropzone
                                        onDrop={this._onDrop}
                                    >
                                        {({getRootProps}) => (
                                            <div className="m-dropzone dropzone dz-clickable" {...getRootProps()}>
                                                <div
                                                    className="m-dropzone__msg dz-message needsclick">
                                                    <h3 className="m-dropzone__msg-title">
                                                        <Trans>frontend.crewmember.upload.title</Trans>
                                                    </h3>
                                                    <span className="m-dropzone__msg-desc">
                                                        <Trans>frontend.crewmember.upload.description</Trans>
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    </Dropzone>
                                </div>
                            )}
                        </div>
                        <div className="col-lg-6">
                            <div className="form-group m-form__group">
                                <label>Working Days:</label>
                                <FullCalendar
                                    selectable
                                    handleSelect={this._handleDateSelection}
                                    dayRender={this._dayRender}
                                    validRange={validRange}
                                    middle={focusedCalendarDate}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={close}>
                        Close
                    </button>
                    <button type="submit" className="btn btn-primary">
                        Save
                    </button>
                </div>
            </form>
        );
    }
}

const CrewMemberForm = withFormik({
    mapPropsToValues: props => {
        const cm = baseValue(props.crewMember, {});
        console.log('combi', cm)
        let values = {
            crewMemberId: baseValue(props.crewMemberId),
            id: baseValue(cm.id),
            userId: baseValue(cm.userId),
            profileId: baseValue(cm.profileId),
            // occupationId: baseValue(cm.occupationId),
            occupation: baseValue(cm.occupation),
            camping: cm.camping ?? false,
            allowCombiVouchers: cm.allowCombiVouchers,
            days: baseValue(cm.days, []),
            vouchers: false,
            vegetarian: false
        };

        return values;
    },
    validate: (values, props) => {
        let errors = {};
        if (props.admin) {
            if (
                (!values.userId || values.userId === "") &&
                (!values.firstName ||
                    values.firstName === "" ||
                    !values.lastName ||
                    values.lastName === "")
            ) {
                errors.userId =
                    "Choose between an existing Employee of create a new one.";
                errors.firstName =
                    "Choose between an existing Employee of create a new one.";
                errors.lastName =
                    "Choose between an existing Employee of create a new one.";
            }

            if (values.userId && (values.firstName || values.lastName)) {
                errors.userId =
                    "Choose between an existing Employee of create a new one.";
                errors.firstName =
                    "Choose between an existing Employee of create a new one.";
                errors.lastName =
                    "Choose between an existing Employee of create a new one.";
            }
        } else {
            if (!values.userId || values.userId === "") {
                errors.userId = "required";
            }
        }

        if (!values.profileId || values.profileId === "") {
            errors.profileId = "required";
        }

        if (!values.occupation || values.occupation === '') {
            errors.occupation = 'required';
        }

        return errors;
    },

    handleSubmit: (values, {props}) => {
        props.onSubmit(values);
    }
})(InnerForm);

export default CrewMemberForm;
